export default [
  {
    path: 'printing/license_index',
    name: 'PrintingLicenseIndex',
    component: () => import('@/views/Printing/LicenseIndex.vue'),
    props: true,
    meta: {
      name: 'printing-license-index',
      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'create-license/:licenseTypeId/:licenseTemplateId',
    name: 'createLicense',
    component: () => import('@/views/License/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-licenses',
      template: 'auth',
    },
  },
  {
    path: 'create-other-license/:licenseTypeId',
    name: 'createOtherLicense',
    component: () => import('@/views/License/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-licenses',
      template: 'auth',
    },
  },
  {
    path: 'license-edit/:licenseId/:licenseVersionId',
    name: 'OldLicenseUpdateVersion',
    component: () => import('@/views/License/CurrentVersionUpdate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-licenses',
      template: 'auth',
    },
  },
  {
    path: 'license-update/:licenseId',
    name: 'licenseUpdate',
    component: () => import('@/views/License/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-licenses',
      template: 'auth',
    },
  },
  {
    path: 'licenses',
    name: 'licenses',
    component: () => import('@/views/License/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-licenses',
      template: 'auth',
    },
  },
  {
    path: 'print-license-index',
    name: 'printLicenseIndex',
    component: () => import('@/views/Printing/LicenseIndex.vue'),
    props: true,
    meta: {
      name: 'printing-license-index',
      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'license-list',
    name: 'licenseList',
    component: () => import('@/views/License/List/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-license',
      template: 'auth',
    },
  },
  {
    path: 'license-create-standard/:licenseTypeId/:licenseTemplateId',
    name: 'licenseCreate',
    component: () => import('@/views/License/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-license',
      template: 'auth',
    },
  },
  {
    path: 'license-create-other/:licenseTypeId',
    name: 'licenseCreateOther',
    component: () => import('@/views/License/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-license',
      template: 'auth',
    },
  },
  {
    path: 'license-content-main/:licenseId',
    name: 'licenseContent',
    component: () => import('@/views/License/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-license',
      template: 'auth',
    },
  },
  {
    path: 'license/:licenseId/license-version-update/:licenseVersionId',
    name: 'licenseUpdateVersion',
    component: () => import('@/views/License/CurrentVersionUpdate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-license',
      template: 'auth',
    },
  },
  {
    path: 'license/:licenseId/license-version-create',
    name: 'licenseCreateVersion',
    component: () => import('@/views/License/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-license',
      template: 'auth',
    },
  },
  {
    path: 'license-template-main/:templateId',
    name: 'licenseTemplateContent',
    component: () => import('@/views/License/ShowTemplate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-license',
      template: 'auth',
    },
  },
];
